import React, { useEffect, useState } from "react";
import Navbar from "../widgets/Navbar";
import PartnerSidebar from "../widgets/PartnerSidebar";
import { useTranslation } from "react-i18next";
import { useGetBrokerRulesQuery } from "../../redux/partnerApi";
import { use } from "react";

const PartnerReport = () => {
  const { t } = useTranslation();
  const { data } = useGetBrokerRulesQuery();
  const [rebateData, setRebateData] = useState([]);

  useEffect(() => {
    if (data) {
      console.log("Broker Rules Data: ", data);
      setRebateData(data);
    }
  }, [data]);

  const showRebateData = () => {
    if (rebateData.length > 0) {
      console.log("Rebate Data: ", rebateData);
      return rebateData?.map((item, index) => (
        <tr key={index}>
          <td>{item.name}</td>
          <td>
            {item.symbols.map((symbol, idx) => (
              <span key={idx} className="symbols_btn border br10 mb-2 mr-2">
                {symbol}
              </span>
            ))}
          </td>
          <td>{item.totalRebate}</td>
          <td>{item.masterShare}</td>
          <td>
            <button className="btn">
              <i className="bi bi-pencil"></i>
            </button>
          </td>
        </tr>
      ));
    } else {
      return (
        <tr>
          <td colSpan="5" className="text-center">
            {t("No data available")}
          </td>
        </tr>
      );
    }
  };

  return (
    <div>
      <Navbar />
      <section className="p70  pt-md-5 pb-md-5">
        <div className="container ">
          <div className="row ">
        <PartnerSidebar />
        <div className="col-xl-9 col-lg-8">
        <h5 className="mb-3">{t("IB Distribution Rules")}</h5>
        <div className="p-3 p-md-4 bg2 br10">
          <div className="table-responsive">
            <table className="table table-borderbb">
              <tr>
                <th>REBATE RULE</th>
                <th>SYMBOLS</th>
                <th>TOTAL REBATE</th>
                <th>MASTER SHARE</th>
                <th>ACTION</th>
              </tr>
              {showRebateData()}
            </table>
          </div>
        </div>
        </div>
        </div>
        </div>
      </section>
    </div>
  );
};

export default PartnerReport;
